import NumAbbr from 'number-abbreviate';

export const ABBREVIATION_THRESHOLD = 1000;

const numAbbr = new NumAbbr(['k', 'M', 'B', 'T']);

export default (nr: any): string => {
  const parsedNumber = Number.parseFloat(nr);

  if (isNaN(parsedNumber)) {
    return 'NaN';
  }

  // if the absolute value of a number is less than thousand
  // and if the number has decimals, round it to two decimals.
  if (
    Math.abs(parsedNumber) < ABBREVIATION_THRESHOLD &&
    parsedNumber % 1 !== 0
  ) {
    // the `+` drops any extra zeros
    return String(+parsedNumber.toFixed(2));
  }

  /**
   * Only add 1 decimal if the formatted number length is 2 digits or less
   * E.g. 123456 will be 123K, 12345678 will be 12.3M
   */
  const numberLength = parsedNumber.toFixed(0).length;
  const decimalCount = numberLength % 3 === 0 ? 0 : 1;

  return numAbbr.abbreviate(nr, decimalCount);
};
